import React from 'react';

const InvoiceTableContext = React.createContext('invoice_context');

export const InvoiceTableContextProvider = InvoiceTableContext.Provider;

export default InvoiceTableContext;
